(function () {
  'use strict';

  var READY_DELAY_MS = 2000;
  var FORM_SELECTOR = 'form input[name="contact[website]"]';

  function setupForm(form) {
    if (!form || form.dataset.spamGuardReady === 'true') return;
    form.dataset.spamGuardReady = 'true';
    form.dataset.spamGuardReadyAt = String(Date.now() + READY_DELAY_MS);

    form.addEventListener('submit', function (event) {
      var honeypot = form.querySelector('input[name="contact[website]"]');
      var filledHoneypot = honeypot && honeypot.value && honeypot.value.trim() !== '';
      var tooFast = Date.now() < Number(form.dataset.spamGuardReadyAt || 0);
      var duplicate = form.dataset.spamGuardSubmitting === 'true';

      if (filledHoneypot || tooFast || duplicate) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
      }

      form.dataset.spamGuardSubmitting = 'true';
      window.setTimeout(function () {
        form.dataset.spamGuardSubmitting = 'false';
      }, 10000);
    }, true);
  }

  function setupForms() {
    document.querySelectorAll(FORM_SELECTOR).forEach(function (honeypot) {
      setupForm(honeypot.closest('form'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupForms);
  } else {
    setupForms();
  }

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(setupForms).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
